import React from "react";
import UkReqMain from "./UkReqMain";
import "./../../UaeAttestation/UaeReq/UaeReq.css";

const UkReq = () => {
  return (
    <div className="uaeReqContainer">
      <UkReqMain />
    </div>
  );
};

export default UkReq;
